import { createAction } from 'redux-actions';
import { RESET, SET_ALL_POLICIES, SET_TOTAL, SET_LOADING } from './actionTypes';
import { getPolicies } from './service';
import STATUS_CODE from '../../../request/statusCode';

const setAllPolicies = createAction(SET_ALL_POLICIES);

const setTotal = createAction(SET_TOTAL);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getAllPolicies = ({ page, size, keyword }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getPolicies({ page, size, keyword }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const { content, totalElements } = res.data;
        dispatch(setAllPolicies(content));
        dispatch(setTotal(totalElements));
      } else {
        dispatch(setAllPolicies([]));
        dispatch(setTotal(0));
      }
    });
  };
};

export { getAllPolicies, setAllPolicies, setTotal, reset, setLoading };
